document.addEventListener('DOMContentLoaded', function () {
  function fixJudgeMeBadge() {
    var starsEl = document.querySelector('.jdgm-prev-badge__stars');
    var textEl = document.querySelector('.jdgm-prev-badge__text');
    if (!starsEl || !textEl) return false;

    var score = starsEl.getAttribute('data-score') || '4.75';
    var reviewText = textEl.textContent.trim(); // e.g. "4.8 • 406 reviews"

    // Extract just the review count part, e.g. "406 reviews"
    var reviewCountMatch = reviewText.match(/[\d,]+\s*reviews?/i);
    var reviewCountText = reviewCountMatch ? reviewCountMatch[0] : reviewText;

    starsEl.setAttribute('aria-label', score + ' out of 5 stars, ' + reviewCountText);

    // Text stays visible for sighted users but is removed from the accessibility tree,
    // since its content is now included in the stars span's aria-label
    textEl.setAttribute('aria-hidden', 'true');

    return true;
  }

  if (!fixJudgeMeBadge()) {
    var observer = new MutationObserver(function () {
      if (fixJudgeMeBadge()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});



// Cart: Product graphic link and name are redundant links


document.addEventListener('DOMContentLoaded', function () {
  var FOCUSABLE_SELECTOR = 'a, button, select, input, textarea, [tabindex]';

  // ---------- Fix 1: Cart line item redundant image link + price tabindex ----------
  function fixLineItemA11y(item) {
    var imageLinks = item.querySelectorAll('.rebuy-cart__flyout-item-media a');
    imageLinks.forEach(function (link) {
      if (link.getAttribute('data-a11y-fixed') !== 'true') {
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
        link.setAttribute('data-a11y-fixed', 'true');
      }
    });

    var priceSpans = item.querySelectorAll('.rebuy-money span[tabindex]');
    priceSpans.forEach(function (span) {
      span.removeAttribute('tabindex');
    });
  }

  function scanForLineItems(root) {
    if (root.matches && root.matches('.rebuy-cart__flyout-item')) {
      fixLineItemA11y(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.rebuy-cart__flyout-item').forEach(fixLineItemA11y);
    }
  }

  // ---------- Fix 2: Recommendation carousel — disable focusables in hidden slides ----------
  function disableFocusables(block) {
    var focusables = block.querySelectorAll(FOCUSABLE_SELECTOR);
    focusables.forEach(function (el) {
      if (el.dataset.a11yOriginalTabindex === undefined) {
        el.dataset.a11yOriginalTabindex = el.hasAttribute('tabindex')
          ? el.getAttribute('tabindex')
          : 'none';
      }
      el.setAttribute('tabindex', '-1');
    });
  }

  function restoreFocusables(block) {
    var restored = block.querySelectorAll('[data-a11y-original-tabindex]');
    restored.forEach(function (el) {
      var original = el.dataset.a11yOriginalTabindex;
      if (original === 'none') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', original);
      }
      delete el.dataset.a11yOriginalTabindex;
    });
  }

  function syncBlock(block) {
    var hidden = block.getAttribute('aria-hidden') === 'true';
    if (hidden) {
      disableFocusables(block);
    } else {
      restoreFocusables(block);
    }
  }

  function syncAllBlocks(root) {
    var blocks = root.querySelectorAll ? root.querySelectorAll('.rebuy-product-block') : [];
    blocks.forEach(syncBlock);
  }

  // ---------- Fix 3: Flyout items container tabindex ----------
  function fixFlyoutItemsTabindex(el) {
    if (el.getAttribute('data-a11y-fixed') === 'true') return;
    el.setAttribute('tabindex', '-1');
    el.setAttribute('data-a11y-fixed', 'true');
  }

  function scanForFlyoutItems(root) {
    if (root.matches && root.matches('[data-smartcart-items]')) {
      fixFlyoutItemsTabindex(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-smartcart-items]').forEach(fixFlyoutItemsTabindex);
    }
  }

  // ---------- Single shared observer running all three fixes ----------

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // aria-hidden attribute changes (carousel slide selection changing)
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-hidden' &&
        mutation.target.classList &&
        mutation.target.classList.contains('rebuy-product-block')
      ) {
        syncBlock(mutation.target);
      }

      // New nodes added (cart drawer opening, items added, widget loading, etc.)
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        scanForLineItems(node);
        scanForFlyoutItems(node);

        if (node.classList && node.classList.contains('rebuy-product-block')) {
          syncBlock(node);
        }
        if (node.querySelectorAll) {
          var nested = node.querySelectorAll('.rebuy-product-block');
          if (nested.length > 0) {
            syncAllBlocks(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true,
    subtree: true
  });

  // Initial pass in case any of this content already exists in the DOM at load time
  scanForLineItems(document.body);
  syncAllBlocks(document.body);
  scanForFlyoutItems(document.body);
});

// toki loyality app working


(function () {
  var CSS_TO_INJECT = `
    .toki-wallet--tab-bar-button.toki-wallet--tab-bar-close-button-visible:focus-visible {
      outline: 2px solid #000 !important;
      outline-offset: 1px !important;
    }

    .toki-wallet--tab-bar-button .toki-wallet--tab-bar-close-text,
    .toki-wallet--tab-bar-button .toki-wallet--tab-bar-close-text svg {
      fill: #153b50 !important;
      color: #153b50 !important;
    }

    .toki-wallet--slider-view-item:focus-visible {
      outline: 2px solid #000 !important;
      outline-offset: 1px !important;
    }
    .toki-wallet--slider-view-item {
      padding: 2px;
      margin: 7px 0px;
    }
    .toki-wallet--base-button-normal:focus-visible {
      outline: 2px solid #000 !important;
      outline-offset: 1px !important;
    }
    .toki-wallet--tab-bar-button-full-width:focus-visible {
      outline: 2px solid #000 !important;
      outline-offset: 1px !important;
    }
    .toki-wallet--tab-bar-button-fit-width {
      margin: 3px;
    }
  `;

  function injectStyleIntoShadowRoot(shadowRoot) {
    if (shadowRoot.querySelector('style[data-a11y-injected="true"]')) return; // avoid duplicate injection
    var styleEl = document.createElement('style');
    styleEl.setAttribute('data-a11y-injected', 'true');
    styleEl.textContent = CSS_TO_INJECT;
    shadowRoot.appendChild(styleEl);
  }

  function findAndInjectShadowRoots(root) {
    var allElements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    allElements.forEach(function (el) {
      if (el.shadowRoot) {
        injectStyleIntoShadowRoot(el.shadowRoot);
        // Recurse in case there's a shadow root nested inside another shadow root
        findAndInjectShadowRoots(el.shadowRoot);
      }
    });
  }

  function watchForShadowRoots() {
    var observer = new MutationObserver(function () {
      findAndInjectShadowRoots(document.body);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial pass in case Toki's widget already exists at load time
    findAndInjectShadowRoots(document.body);
  }

  document.addEventListener('DOMContentLoaded', watchForShadowRoots);
})();


(function () {
  var LINK_ITEM_SELECTOR = '.toki-wallet--link-option-item';

  function makeFocusable(el) {
    if (el.getAttribute('data-a11y-fixed') === 'true') return;

    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('data-a11y-fixed', 'true');

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });

  }

  function scanShadowRootForLinks(shadowRoot) {
    var items = shadowRoot.querySelectorAll(LINK_ITEM_SELECTOR);
    items.forEach(makeFocusable);
  }

  function findAndFixShadowRoots(root) {
    var allElements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    allElements.forEach(function (el) {
      if (el.shadowRoot) {
        scanShadowRootForLinks(el.shadowRoot);
        findAndFixShadowRoots(el.shadowRoot); // handle nested shadow roots, if any
      }
    });
  }

  function watchForShadowRoots() {
    var observer = new MutationObserver(function () {
      findAndFixShadowRoots(document.body);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial pass in case the widget already exists at load time
    findAndFixShadowRoots(document.body);
  }

  document.addEventListener('DOMContentLoaded', watchForShadowRoots);
})();

// Capthca code 



(function () {
  var CSS_TO_INJECT = `
    #shop-hcaptcha-badge-container:focus-visible {
      outline: 2px solid #000 !important;
      outline-offset: 2px !important;
      border-radius: 4px;
    }
  `;

  function injectFocusStyles() {
    if (document.getElementById('captcha-a11y-styles')) return; // avoid duplicate injection
    var styleEl = document.createElement('style');
    styleEl.id = 'captcha-a11y-styles';
    styleEl.textContent = CSS_TO_INJECT;
    document.head.appendChild(styleEl);
  }

  function makeCaptchaBadgeAccessible(container) {
    if (container.getAttribute('data-a11y-fixed') === 'true') return;

    container.setAttribute('tabindex', '0');
    container.setAttribute('role', 'button');
    container.setAttribute('aria-label', 'Protected by hCaptcha. Press Enter to view privacy and terms links.');
    container.setAttribute('data-a11y-fixed', 'true');

    var infoPanel = container.querySelector('.info');

    function showInfo() {
      container.style.transform = 'translateX(calc(-100% + 56px))';
      if (infoPanel) {
        infoPanel.style.display = 'flex';
        infoPanel.style.opacity = '1';
        infoPanel.style.visibility = 'visible';
      }
    }

    function hideInfo() {
      container.style.transform = '';
      if (infoPanel) {
        infoPanel.style.display = '';
        infoPanel.style.opacity = '';
        infoPanel.style.visibility = '';
      }
    }

    container.addEventListener('focus', showInfo);
    container.addEventListener('blur', function () {
      setTimeout(function () {
        if (!container.contains(document.activeElement)) {
          hideInfo();
        }
      }, 100);
    });

    if (infoPanel) {
      var innerLinks = infoPanel.querySelectorAll('a');
      innerLinks.forEach(function (link) {
        link.addEventListener('focus', showInfo);
        link.addEventListener('blur', function () {
          setTimeout(function () {
            if (!container.contains(document.activeElement)) {
              hideInfo();
            }
          }, 100);
        });
      });
    }

    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        showInfo();
        if (innerLinks && innerLinks.length > 0) {
          innerLinks[0].focus();
        }
      }
    });

  }

  function scanForCaptchaBadge(root) {
    if (root.matches && root.matches('#shop-hcaptcha-badge-container')) {
      makeCaptchaBadgeAccessible(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('#shop-hcaptcha-badge-container').forEach(makeCaptchaBadgeAccessible);
    }
  }

  function watchForCaptchaBadge() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          scanForCaptchaBadge(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    scanForCaptchaBadge(document.body);
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectFocusStyles();
    watchForCaptchaBadge();
  });
})();

// navigation mobile

(function () {
  function openSubmenu(panel, triggerButton) {
    // Fix 1: The core bug - hidden attribute must be removed, not just aria-hidden
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('nav__secondary-menu__item--visible', 'nav__secondary-menu__item--animate-in');

    if (triggerButton) {
      triggerButton.setAttribute('aria-expanded', 'true');
    }

    // Move focus into the panel for keyboard/screen reader users
    var closeButton = panel.querySelector('.nav__secondary-menu__close');
    if (closeButton) {
      closeButton.focus();
    }

  }

  function closeSubmenu(panel, triggerButton) {
    panel.setAttribute('hidden', '');
    panel.setAttribute('aria-hidden', 'true');
    panel.classList.remove('nav__secondary-menu__item--visible', 'nav__secondary-menu__item--animate-in');

    if (triggerButton) {
      triggerButton.setAttribute('aria-expanded', 'false');
      triggerButton.focus(); // return focus to the button that opened it
    }

  }

  function closeAllSiblingSubmenus(exceptPanel) {
    var allPanels = document.querySelectorAll('.nav__secondary-menu__item');
    allPanels.forEach(function (panel) {
      if (panel !== exceptPanel && !panel.hasAttribute('hidden')) {
        var relatedButton = document.querySelector('[aria-controls="' + panel.id + '"]');
        closeSubmenu(panel, relatedButton);
      }
    });
  }

  document.addEventListener('click', function (e) {
    // Opening: button with data-targetmenu
    var openTrigger = e.target.closest('[data-targetmenu]');
    if (openTrigger) {
      var targetId = openTrigger.getAttribute('data-targetmenu');
      var targetPanel = document.getElementById(targetId);
      if (targetPanel) {
        closeAllSiblingSubmenus(targetPanel);
        openSubmenu(targetPanel, openTrigger);
      }
      return;
    }

    // Closing: the "Back" button inside a panel
    var closeTrigger = e.target.closest('.nav__secondary-menu__close');
    if (closeTrigger) {
      var panel = closeTrigger.closest('.nav__secondary-menu__item');
      if (panel) {
        var relatedButton = document.querySelector('[aria-controls="' + panel.id + '"]');
        closeSubmenu(panel, relatedButton);
      }
    }
  });

  // Also allow Escape key to close the currently open submenu
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openPanel = document.querySelector('.nav__secondary-menu__item:not([hidden])');
      if (openPanel) {
        var relatedButton = document.querySelector('[aria-controls="' + openPanel.id + '"]');
        closeSubmenu(openPanel, relatedButton);
      }
    }
  });
})();


/* ADA FIX START: Recent-search button labels */
(function () {
  if (window.lhRecentSearchLabelsLoaded) return;
  window.lhRecentSearchLabelsLoaded = true;

  function updateRecentSearchLabels() {
    document.querySelectorAll('.recent-searches__item').forEach(function (item) {
      var searchButton = item.querySelector('.search-sidebar__button');
      var removeButton = item.querySelector('.search-sidebar__remove');

      var term = searchButton
        ? searchButton.textContent.trim()
        : '';

      if (!term && removeButton) {
        term = (removeButton.getAttribute('data-search') || '').trim();
      }

      if (!term) return;

      if (searchButton) {
        searchButton.setAttribute('aria-label', 'Search again for ' + term);
      }

      if (removeButton) {
        removeButton.setAttribute(
          'aria-label',
          'Remove ' + term + ' from recent searches'
        );
      }
    });
  }

  function init() {
    updateRecentSearchLabels();

    var scheduled = false;

    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;
        updateRecentSearchLabels();
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* ADA FIX END */


/* ADA FIX START: Rebuy cart heading levels — SR rows 12, 13, 14 */
(function () {
  if (window.lhCartHeadingLevelsLoaded) return;
  window.lhCartHeadingLevelsLoaded = true;

  function replaceHeading(element, tagName) {
    var replacement = document.createElement(tagName);

    // Preserve existing classes, IDs, and other attributes.
    Array.from(element.attributes).forEach(function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });

    // Preserve existing content and child elements.
    while (element.firstChild) {
      replacement.appendChild(element.firstChild);
    }

    element.replaceWith(replacement);
  }

  function fixCartHeadingLevels() {
    // SR row 12: "Your Goods" — h2 to h1.
    document.querySelectorAll(
      'h2#SmartCart_title.rebuy-cart__flyout-title'
    ).forEach(function (heading) {
      replaceHeading(heading, 'h1');
    });

    // SR row 13: "Your cart is empty!" — h4 to h2.
    document.querySelectorAll(
      '.rebuy-cart h4.ql-align-center, ' +
      '.rebuy-cart__flyout h4.ql-align-center'
    ).forEach(function (heading) {
      var text = heading.textContent.replace(/\s+/g, ' ').trim();

      if (/^your cart is empty[!.]?$/i.test(text)) {
        replaceHeading(heading, 'h2');
      }
    });

    // SR row 14: "You may also like" — h4 to h2.
    document.querySelectorAll(
      '.rebuy-cart h4.primary-title, ' +
      '.rebuy-cart__flyout h4.primary-title'
    ).forEach(function (heading) {
      var text = heading.textContent.replace(/\s+/g, ' ').trim();

      if (/^you may also like[!.]?$/i.test(text)) {
        replaceHeading(heading, 'h2');
      }
    });
  }

  function init() {
    fixCartHeadingLevels();

    var scheduled = false;

    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;
        fixCartHeadingLevels();
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* ADA FIX END */

/* ADA FIX START: Search skip-link focus handling */
(function () {
  if (window.lhSearchSkipLinkLoaded) return;
  window.lhSearchSkipLinkLoaded = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.skip-to-main-category');
    if (!link) return;

    var searchContainer = link.closest(
      '.predictive-search__results-container'
    );
    if (!searchContainer) return;

    // Find the results belonging to this search panel.
    var results = searchContainer.querySelector('.search-products');
    if (!results) return;

    event.preventDefault();
    event.stopPropagation();

    results.setAttribute('tabindex', '-1');
    results.focus({ preventScroll: true });
    results.scrollIntoView({
      block: 'nearest',
      inline: 'nearest'
    });
  }, true);
})();
/* ADA FIX END */